import { reactive } from 'vue';
import { getDefaultState } from './default_state';

const state: State = reactive(getDefaultState());

export { state };
